import { render, staticRenderFns } from "./isMarkedTemplate.vue?vue&type=template&id=28e9e01d"
import script from "./isMarkedTemplate.vue?vue&type=script&lang=js"
export * from "./isMarkedTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports